import { gql } from '@apollo/client'
import { IMAGE_FRAGMENT } from './ImageFragment'

export const PLANOGRAM_IMAGES_FRAGMENT = gql`
  fragment PlanogramImages on PlanogramProductImages {
    normal {
      ...Image
    }
    thumbnail {
      ...Image
    }
  }
  ${IMAGE_FRAGMENT}
`
